import { HomeIcon, Link } from '@/components';
import { transformString } from '@/utils';
import { ArrowRightIcon, Box, Flex, textShortener } from '@blockanalitica/ui';
import { ReactNode, useMemo } from 'react';

type TCrumb = {
  href: string;
  text: ReactNode;
};

type BreadcrumbsProps = {
  crumbs: TCrumb[];
};

export default function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  return (
    <Flex gap="3xs" display="inline-flex" alignItems="center">
      <Crumb key="/" last={false} text={<HomeIcon size="1" />} href="/" />

      {crumbs.map((crumb, index) => (
        <Crumb
          key={crumb.href}
          last={crumbs.length === 1 || index === crumbs.length - 1}
          {...crumb}
        />
      ))}
    </Flex>
  );
}

type TCrumbProps = TCrumb & {
  last: boolean;
};

function Crumb({ href, text, last }: TCrumbProps) {
  const crumbChildren = useMemo(() => {
    if (typeof text === 'string') {
      if (text.startsWith('0x')) {
        return textShortener(text, {
          threshold: 15,
          firstSliceLength: 6,
          secondSliceLength: 4
        });
      }
      if (text === 'Stusds') {
        return 'stUSDS';
      }
      return textShortener(transformString(text), {
        threshold: 63,
        firstSliceLength: 4,
        secondSliceLength: 4
      });
    }

    return text;
  }, [text]);

  if (last) {
    return <Box color="muted">{crumbChildren}</Box>;
  }

  return (
    <Flex display="inline-flex" gap="3xs" alignItems="center">
      <Link to={href}>
        <Flex color="muted" hover={{ color: 'colors.linkHover' }}>
          {crumbChildren}
        </Flex>
      </Link>
      <Box color="muted">
        <ArrowRightIcon size="-1" />
      </Box>
    </Flex>
  );
}
